import { Dropdown, DropdownMenuItemType, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { ITextFieldStyles, TextField } from 'office-ui-fabric-react/lib/TextField';
import React, { useContext, useState } from 'react';
import Context from '../context';
import { ActionTypes } from '../types/types';

import { Resources } from './resources';

const smallWorkflow = require('../sampleworkflows/smallworkflow.json');
const mediumWorkflow = require('../sampleworkflows/mediumworkflow.json');
const largeWorkflow = require('../sampleworkflows/largeworkflow.json');

const textFieldStyles: Partial<ITextFieldStyles> = {
    field: {
        minHeight: '500px',
        backgroundColor: '#f2f2f2ab',
        fontSize: '13px'
    }
};

export const BrowseWorkflow = () => {
    const _inputFile = React.createRef<HTMLInputElement>();
    const { state, dispatch } = useContext(Context);
    const [selectedKey, setSelectedKey] = useState<string | number | null>(null);

    const _options: IDropdownOption[] = [
        { key: '1', text: Resources.EXAMPLE_WORKFLOW_SMALL },
        { key: '2', text: Resources.EXAMPLE_WORKFLOW_MEDIUM },
        { key: '3', text: Resources.EXAMPLE_WORKFLOW_LARGE },
        { key: 'divider_1', text: '-', itemType: DropdownMenuItemType.Divider },
        { key: '4', text: Resources.BROWSE_BUTTON_TEXT }
    ];

    const _handleTextFieldChange = (_: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined): void => {
        const action = {
            type: ActionTypes.UPDATE_WORKFLOW_DEFINITION,
            payload: newValue || ''
        };
        dispatch(action);
    }

    const _onButtonClick = () => {
        if (_inputFile.current) {
            _inputFile.current.click();
        }
    };
    
    const _onInputButtonClick = (e: React.MouseEvent<HTMLInputElement>) => {
        const element = e.target as HTMLInputElement;
        element.value = '';
    };

    const _onChangeFile = async(files: FileList | null) => {
        if (files) {
            const workflowFile = files[0];
            if (workflowFile) {
                await workflowFile.text().then(text => {
                    const action = {
                        type: ActionTypes.UPDATE_WORKFLOW_DEFINITION,
                        payload: text || ''
                    };
                    dispatch(action);
                });
                setSelectedKey(null);
            }
        }
    }

    const _onChangeSamplesDropdown = (e: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined) => {
        if (option) {
            let workflowDefinition = '';
            switch(option.key) {
                case '1':
                    workflowDefinition = JSON.stringify(smallWorkflow, null, 4);
                    break;
                case '2':
                    workflowDefinition = JSON.stringify(mediumWorkflow, null, 4);
                    break;
                case '3':
                    workflowDefinition = JSON.stringify(largeWorkflow, null, 4);
                    break;
                case '4':
                    _onButtonClick();
                    break;
            }
            setSelectedKey(option.key);

            if (option.key !== '4') {
                const action = {
                    type: ActionTypes.UPDATE_WORKFLOW_DEFINITION,
                    payload: workflowDefinition
                };
                dispatch(action);
            }
        }
    }

    return (
        <div className="calc-workflow-upload-container">
            <div className="calc-browse-container">
                <Label className="calc-browse-label">{Resources.BROWSE_LABEL}</Label>
                <input type='file' id='file' onChange={e => {_onChangeFile(e.target.files)}} onClick={_onInputButtonClick} ref={_inputFile} style={{display: 'none'}}/>
                <Dropdown
                    aria-label={Resources.EXAMPLE_WORKFLOW_DROPDOWN_ARIA_LABEL}
                    className="calc-examples-dropdown"
                    options={_options}
                    placeholder={Resources.SELECT_WORKFLOW_PLACEHOLDER_TEXT}
                    selectedKey={selectedKey}
                    onChange={_onChangeSamplesDropdown}/>
            </div>
            <TextField className="calc-workflow-paste-textfield" styles={ textFieldStyles } resizable={false} multiline value={state.workflowDefinition} onChange={_handleTextFieldChange}/>
            {state.errorMessage !== ''
                ? <div className="calc-workflow-invalid">{state.errorMessage}</div>
                : undefined
            }
        </div>
    );
}